<p>
  stop-and-go works!
</p>
